import * as React from "react";
import {
  Create,
  FileField,
  FileInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { validateRequired } from "../utils/Validations";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const BillingCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [errors, setErrors] = React.useState([]);
  const onSuccess = (data, ...rest) => {
    if (data?.errors?.length) {
      handleOpen(true);
      setErrors(data.errors);
      return;
    }
    notify(`Changes saved`);
    redirect(`/billing`);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrors([]);
    redirect("/billing");
  };

  return (
    <Create
      title="Facturar"
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess }}
    >
      <SimpleForm>
        <BasicModal
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
          data={errors}
        />
        <FileInput
          source="file"
          label="Ingrese CSV con los datos de facturación"
          validate={validateRequired}
        >
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default BillingCreate;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500, // Increase width for better layout
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  borderRadius: "10px", // Add rounded corners for a cleaner look
  p: 4,
};

const mapErrorToField = {
  GiroRecep: "Actividad",
  RUTRecep: "Rut",
  RznSocRecep: "Razon social",
  CmnaRecep: "Comuna",
  DirRecep: "Dirección",
};

// Component to render error details with improved styling
function ErrorDetails({ details }) {
  return (
    <>
      {details?.map((detail, index) => (
        <Box key={index} sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary">
            Campo: <b>{mapErrorToField[detail?.field] || detail.field}</b>
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Razón: {detail?.issue}
          </Typography>
        </Box>
      ))}
    </>
  );
}

// Component to render a single local error with professional styling
function BillingError({ error }) {
  const { restaurantName, reason } = error;

  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        p: 2,
        mb: 2,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {restaurantName}
      </Typography>
      <Typography variant="body1" color="error" sx={{ fontWeight: "bold" }}>
        Motivo: {reason?.error?.message}
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Código: {reason?.error?.code}
      </Typography>
      <ErrorDetails details={reason?.error?.details} />
    </Box>
  );
}

export function BasicModal({ open, handleClose, data }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
          Algunas facturas fallaron al crearse
        </Typography>
        <Box
          id="modal-description"
          sx={{ maxHeight: "400px", overflowY: "auto" }}
        >
          {data?.map((item, index) => (
            <BillingError key={index} error={item.data} />
          ))}
        </Box>
      </Box>
    </Modal>
  );
}
